import React from 'react';
import PropTypes from 'prop-types';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';
import GarageCashPurchase from 'commons-garage/components/GarageCashPurchase/GarageCashPurchase.jsx';
import GarageFinance from 'commons-garage/components/GarageFinance/GarageFinance.jsx';
import 'commons-garage/components/GarageVehicle/VehiclePayments/VehiclePayments.scss';

const VehiclePayments = ({ quote, vehicle }) => {
    const isCarAvailable = vehicle.isAvailable();
    const isQuoteInPendingStatus = quote.isQuoteInPending();
    const isQuoteInApprovalStatus = quote.isQuoteInApproval();
    const isCashPurchase = quote.cashPurchase !== null;
    const checkoutRedirectionUrl = quote.getCheckoutUrl();

    const isQuoteWithDeposit = !isQuoteInPendingStatus && isCarAvailable && !isQuoteInApprovalStatus;
    const isQuoteWithoutDeposit = isQuoteInPendingStatus && !isQuoteInApprovalStatus;
    const isQuoteExpired = quote.isExpired;

    const renderedContent = [];
    const renderedCta = [];
    let ctaButton = null;
    const summaryButton = (
        <a href={checkoutRedirectionUrl} className="vehicle-summary sr-button-1 is-small">
            {LocaleService.t('GARAGE.VEHICLE_STATUS.SUMMARY')}
        </a>
    );

    if (isQuoteWithDeposit) {
        ctaButton = (
            <a href={checkoutRedirectionUrl} className="sr-button-1 is-small">
                {LocaleService.t('GARAGE.VEHICLE_STATUS.SELECT')}
            </a>
        );

        if (isCashPurchase) {
            renderedContent.push(<GarageCashPurchase quote={quote} />);
            renderedCta.push(ctaButton);
        } else {
            renderedContent.push(<GarageFinance quote={quote} />);
            renderedCta.push(ctaButton);
        }
    } else if (isQuoteWithoutDeposit) {
        ctaButton = (
            <a href={checkoutRedirectionUrl} className="sr-button-1 is-small is-right">
                {quote.status === Quote.StatusesV25.SOLD || quote.status === Quote.StatusesV25.DELIVERED
                    ? LocaleService.t('GARAGE.VEHICLE_STATUS.SUMMARY')
                    : LocaleService.t('GARAGE.VEHICLE_STATUS.FINALIZE')}
            </a>
        );
        // We need to push an empty span, since the layout is flexed with justify-content: space-between.
        renderedContent.push(<span />);
        renderedCta.push(ctaButton);
    } else if (isQuoteExpired || !isCarAvailable) {
        if (isQuoteInApprovalStatus) {
            renderedCta.push(summaryButton);
        } else {
            renderedContent.push(<span className="is-price">{LocaleService.t('GARAGE.UNAVAILABLE')}</span>);
        }
    } else if (isQuoteInApprovalStatus) {
        renderedCta.push(summaryButton);
    }

    const renderedElements = (
        <div className="garage-vehicle-payments-info">
            <div className="garage-vehicle-payments">{renderedContent}</div>
            <div className="garage-vehicle-payments-button">{renderedCta}</div>
        </div>
    );

    return renderedElements;
};

VehiclePayments.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehiclePayments.displayName = 'VehiclePayments';

export default VehiclePayments;
